/* eslint-disable eqeqeq */
import {
  CmpSelectBox,
  CmpDatePicker,
  CmpTextFieldEnter,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import PrintIcon from "@mui/icons-material/Print";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";
import { fExecuteAPI } from "../../Server/Apis";
import { useSelector } from "react-redux";
import {
  LoadingData_Set,
  LoadingHead_Set,
  PalletHead_Set,
} from "./SliceLoading";
import moment from "moment";
import {
  fAlertToast,
  GetGitterColumns,
  ReportRemoveSequenceChar,
  ReportTitle,
  ReportUrl,
} from "../../Utility/Utilitys";
import Loading_Breadcrumbs from "./Loading_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./Loading.css";
import { LoadingCard } from "./LoadingCard";
import LoadingModal from "./component/LoadingModal";
import LoadingPalletId from "./LoadingPalletId";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import UpdatedTruck from "./UpdatedTruck";
import DetailCardComp, {
  DetailButton,
  DetailInputDisplay,
} from "../../Component/Common/ReuseableComponent/DetailCardComp";
import { Button, Stack } from "@mui/material";

const statusData = [
  {
    id: "Pending",
    statusName: "Pending",
  },
  {
    id: "Completed",
    statusName: "Completed",
  },
  {
    id: "All",
    statusName: "All",
  },
  {
    id: "Progress",
    statusName: "Progress",
  },
];
const Gridcolumns = [
  {
    field: "DocNo",
    headerName: "Doc.No",
    width: 150,
  },
  {
    field: "DocDate",
    headerName: "Date",
    width: 300,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "PartyName",
    headerName: "Party Name",
    width: 300,
  },
  {
    field: "Status",
    headerName: "Status",
    width: 100,
  },
  {
    field: "PDTUser",
    headerName: "User",
    width: 100,
  },
];

export default function LoadingHead() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const LocationLoadingFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const xMediaQuery = useMediaQuery("(max-width:950px)");
  const vRdxuserLoc = useSelector((state) => state.SliceGRNLocation.value);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const vRdxSliceData = useSelector(
    (state) => state.SliceLoading.value.LoadingData
  );
  const [loadingPalletIdOpen, SetLoadingPalletIdOpen] = useState(false);
  const [sLocation, SetLocation] = useState(vRdxuserLoc);
  const [sLoadObj, setLoadObj] = useState(vRdxSliceData);
  const [sGridrows, setGridrows] = useState([]);
  const [selectedData, setSelectedData] = useState({});
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });
  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);

  const [sWebReportModal, setWebReportModal] = React.useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = React.useState("");

  const fOnChangeSelect = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };
  const fOnKeyUp = async (e) => {
    if (e.key === "Enter") {
      if (sLoadObj.Scan != "") {
        let summaryResp = await GetSummaryList(
          sLoadObj.loc,
          sLoadObj.statusVal
        );
        if (summaryResp.length > 0) {
          let resultObj = summaryResp[0];
          dispatch(
            LoadingHead_Set({
              VocTyp: resultObj.DocTyp,
              VocTypName: resultObj.DocName,
              VocNo: resultObj.DocNo,
              PostDate: resultObj.DocDate,
              Party: resultObj.PartyCode,
              PartyName: resultObj.PartyName,
              TruckName: resultObj.Truck,
              Drive: resultObj.Driver,
              LoadingBay: resultObj.LoadingBay,
              Status: resultObj.Status,
              LoadingBayCode: resultObj.LoadingBayCode,
              Loc: sLoadObj.loc,
            })
          );
          navigate("/LoadingDetail");
        } else {
          fAlertToast("FAILED", "Wrong Barcode");
        }
      }
    }
  };
  const fLoad = async (e) => {
    dispatch(LoadingData_Set(sLoadObj));
    let summaryResp = await GetSummaryList(sLoadObj.loc, sLoadObj.statusVal);
    LocationLoadingFocusOnLoad.current?.focus();
  };

  const fOnRowClick = (e) => {
    dispatch(
      LoadingHead_Set({
        VocTyp: e.row.DocTyp,
        VocTypName: e.row.DocName,
        VocNo: e.row.DocNo,
        PostDate: moment(e.row.DocDate, "DD/MM/YYYY")._d,
        Party: e.row.PartyCode,
        PartyName: e.row.PartyName,
        TruckName: e.row.Truck,
        Drive: e.row.Driver,
        LoadingBay: e.row.LoadingBay,
        Status: e.row.Status,
        LoadingBayCode: e.row.LoadingBayCode,
        Loc: sLoadObj.loc,
      })
    );
    navigate("/LoadingDetail");
  };

  const onPalletClick = (e) => {
    setSelectedData(e.row);
    SetLoadingPalletIdOpen(true);
  };

  // Updated Truck
  const [updatedTruck, setUpdatedTruck] = useState(false);

  const CloseUpdatedTruckModal = async () => {
    setSelectedData({});
    setUpdatedTruck(false);
    await GetSummaryList(sLoadObj.loc, sLoadObj.statusVal);
  };

  const fUpdatedTruck = (e) => {
    setSelectedData(e.row);
    setUpdatedTruck(true);
  };

  console.log("selectedData34325", selectedData);
  //1st load
  const onLoadCall = async (e) => {
    dispatch(
      LoadingData_Set({
        loc: vRdxuserLoc[0]?.UID,
        dateFrom: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 10
        ),
        // dateFrom: tenDaysAgo,
        dateTo: new Date(),
        statusVal: statusData[0]?.id,
        Scan: "",
      })
    );
    setLoadObj((obj) => ({
      ...obj,
      loc: vRdxuserLoc[0]?.UID,
      dateFrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate() - 10
      ),
      // dateFrom: tenDaysAgo,
      dateTo: new Date(),
      statusVal: statusData[0]?.id,
      Scan: "",
    }));
    let summaryResp = await GetSummaryList(
      vRdxuserLoc[0]?.UID,
      statusData[0]?.id
    );
    setGridrows(summaryResp);
    // dispatch(LoadingList_Set({
    //   summaryResp
    // }))
  };
  //API LOADING_SUMMARY_GETROW
  const GetSummaryList = async (xLoc, xStatus) => {
    let vSummaryListObj = {
      // loc: 15,
      loc: xLoc,
      date1: moment(sLoadObj.dateFrom).format("MM/DD/YYYY"),
      date2: moment(sLoadObj.dateTo).format("MM/DD/YYYY"),
      status: xStatus,
      scan: sLoadObj.Scan,
      usercd: vRdxuserInfo.UserID,
    };
    const vSummaryList = await fExecuteAPI(
      "LOADING_SUMMARY_GETROW",
      vSummaryListObj
    );
    if (vSummaryList.Type == "SUCCESS") {
      // PostDate: moment(obj.PostDate).format("DD/MM/YYYY")
      let GridID = vSummaryList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
        // DocDate: moment(obj.DocDate).format("MM/DD/YYYY"),
      }));
      setGridrows(GridID);
      setShowModal(false);
      return GridID;
    } else if (vSummaryList.Type == "FAILED") {
      fAlertToast("FAILED", vSummaryList.Message);
      let GridID = vSummaryList.ResultSet?.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridrows(GridID);
      return GridID;
    } else if (
      vSummaryList.response.status == 500 ||
      vSummaryList.response.status == 400
    ) {
      fAlertToast("FAILED", vSummaryList.response.data.message);
      let GridID = [];
      setGridrows(GridID);
      return GridID;
    } else {
      fAlertToast("FAILED", "Error in loading summarylist");
      let GridID = [];
      setGridrows(GridID);
      return GridID;
    }
  };

  const fPrint = async (obj) => {
    if (obj?.DocTyp && obj?.DocNo) {
      let urlPrint = vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val;
      let sCurrentReport = "";
      let sReportTitle = "";

      let ReportTitleObj = {
        VocNo: obj?.DocNo, // "LD001"
        VocTyp: obj?.DocTyp, // "LD00033245"
      };
      // Remove the trailing "&" character
      sReportTitle = ReportTitle(ReportTitleObj);

      let ReportUrlObj = {
        VocNo: obj?.DocNo, // "LD001"
        VocTyp: obj?.DocTyp, // "LD00033245"
        // reportTitle: sReportTitle,
      };
      console.log(ReportUrlObj);
      sCurrentReport = ReportUrl(ReportUrlObj);
      sCurrentReport = ReportRemoveSequenceChar(sCurrentReport);
      // console.log("ReportUrlObj", ReportUrlObj);
      console.log("sCurrentReport", sCurrentReport);
      console.log(
        "sCurrentReport",
        urlPrint + "WMS/LoadingPallet?" + sCurrentReport
      );
      setWebReportUrlModal(urlPrint + "WMS/LoadingPallet?" + sCurrentReport);
      setWebReportModal(true);
    } else {
      fAlertToast("FAILED", "VOC NO AND VOC TYPE NOT FOUND");
    }
  };

  useEffect(() => {
    onLoadCall();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    LocationLoadingFocusOnLoad.current?.focus();
  }, []);
  const [sSummaryGridColumn2, setSummaryGridColumn2] = useState([]);

  useEffect(() => {
    GetGitterColumns(setSummaryGridColumn2, "LOADING_SUMMARY", Gridcolumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end
  return (
    <>
      <div className="container-fluid my-3">
        <div className="Breadcrumbs d-flex">
          {/* eslint-disable-next-line react/jsx-pascal-case */}
          <Loading_Breadcrumbs />
          <CmpButton
            xbtnName="Filter"
            xOnClick={() => {
              setShowModal(true);
            }}
            xVariant="contained"
            xSize="small"
          />
        </div>
        <div style={{ margin: "auto", width: "100%" }}>
          {/* <Grid container spacing={2}>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Location"
              xValue={sLoadObj.loc === "" ? vRdxuserLoc[0]?.UID : sLoadObj.loc}
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"loc"}
              xData={sLocation}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"From"}
              xValue={sLoadObj.dateFrom}
              xOnChange={(newValue) => {
                setLoadObj((obj) => ({ ...obj, dateFrom: newValue.$d }));
              }}
              xName={"dateFrom"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6} className="bintransfer-data-date">
            <CmpDatePicker
              xLabelText={"To"}
              xValue={sLoadObj.dateTo}
              xOnChange={(newValue) =>
                setLoadObj((obj) => ({ ...obj, dateTo: newValue.$d }))
              }
              xName={"dateTo"}
              xError={false}
              xErrorMessage={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={6}>
            <CmpSelectBox
              xLabelText="Status"
              xValue={
                sLoadObj.statusVal == "" ? statusData[0].id : sLoadObj.statusVal
              }
              xOnChange={(event) => fOnChangeSelect(event)}
              xName={"statusVal"}
              xData={statusData}
              xValueMember={""}
              xDispalyMember={""}
              xError={false}
              xErrorMessage={false}
              xDisable={false}
            />
          </Grid>
          <Grid item lg={2} md={4} xs={12}>
            <CmpTextFieldEnter
              xref={LocationLoadingFocusOnLoad}
              xLabelText={"Scan"}
              xVariant={"outlined"}
              xValue={sLoadObj.scan}
              xOnChange={(event) => fOnChangeInput(event)}
              xReadOnly={false}
              xType={"text"}
              xName={"Scan"}
              xOnKeyUp={(e) => {
                fOnKeyUp(e);
              }}
              xOnEnter={(e) => {
                fOnKeyUp(sEnterKeyObj);
              }}
              xSmShow={!!vMediaQuery}
            />
          </Grid>
          <Grid
            item
            lg={2}
            md={4}
            xs={12}
            className="bintransfet-data-load-btn"
          >
            <CmpButton
              xbtnName="Load"
              xOnClick={fLoad}
              xVariant="contained"
              xSize="small"
            />
          </Grid>
        </Grid> */}
          <div
            style={{
              height: xMediaQuery ? "65vh" : "72vh",
              overflowY: "auto",
              marginTop: "14px",
              padding: xMediaQuery ? "0px" : "25px",
            }}
          >
            <Grid container spacing={1}>
              {Array.isArray(sGridrows) &&
                sGridrows?.length > 0 &&
                sGridrows?.map((item, index, row) => (
                  <Grid item xs={12} sm={6} md={6} lg={4} key={index}>
                    <DetailCardComp
                      data={item}
                      // onClick={() => fOnRowClick({ row: item })}
                      headerLabel={item.PartyName}
                      content={
                        <Grid container spacing={1}>
                          <DetailInputDisplay
                            label="Doc.No"
                            value={item.DocNo}
                          />
                          <DetailInputDisplay
                            label="Doc.Date"
                            value={moment(item.DocDate).format("DD/MM/YYYY")}
                          />
                          <DetailInputDisplay
                            label="Status"
                            value={item.Status}
                          />
                          <DetailInputDisplay
                            label="User"
                            value={item.PDTUser}
                          />
                          <DetailInputDisplay label="DC" value={item.Driver} />
                          <DetailInputDisplay
                            label="Truck"
                            value={item.Truck}
                          />
                        </Grid>
                      }
                      action={
                        <Grid item xs={12}>
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{
                              marginTop: 1,
                              flexWrap: { xs: "wrap", sm: "nowrap" },
                              justifyContent: "flex-start",
                            }}
                          >
                            <DetailButton
                              label="Load"
                              xonClick={() => fOnRowClick({ row: item })}
                            />
                            <DetailButton
                              label="Box Pallet"
                              xonClick={() => onPalletClick({ row: item })}
                            />
                            <DetailButton
                              label="Print"
                              icon={<PrintIcon />}
                              xonClick={() => fPrint(item)}
                            />
                            <DetailButton
                              label="Updated Truck"
                              xonClick={() => fUpdatedTruck({ row: item })}
                            />
                          </Stack>
                        </Grid>
                      }
                    />
                  </Grid>
                ))}
            </Grid>
          </div>

          {/* {!vMediaQuery &&<Box
          sx={{ height: vMediaQuery ? "45vh" : "70vh", width: "100%" }}
          className="bin-transfer-data"
        >
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
            }}
            rows={sGridrows}
            columns={sSummaryGridColumn2}
            // pageSize={5}
            // rowsPerPageOptions={[5]}
            hideFooter={sGridrows.length < 100}
            onRowClick={fOnRowClick}
            components={{
              Toolbar: GridToolbar,
            }}
          />
        </Box>}
  */}
          {/* {vMediaQuery && sGridrows?.length > 0 && (
              <Box>
                <Grid
                  container
                  spacing={{ xs: 0, md: 3 }}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  {sGridrows?.map((obj, index) => (
                    <Grid item xs={12} sm={12} md={6} key={index}>
                      <LoadingCard                         
                        DocNo={obj?.DocNo} 
                        PartyName={obj?.PartyName}
                        Status={obj?.Status} 
                        PDTUser={obj?.PDTUser} 
                        DocDate={moment(obj?.DocDate).format("DD/MM/YYYY")}
                        onClick={() => {
                          console.log("asdadsas", obj);
                          let e = {
                            row: obj,
                          };
                          fOnRowClick(e);
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>
            )} */}
        </div>
        <LoadingModal
          xOpen={showModal}
          fCloseModal={() => {
            setShowModal(false);
          }}
          xTitle="Filter"
          component={
            <>
              <Grid container spacing={2}>
                <Grid item md={4} xs={6}>
                  <CmpSelectBox
                    xLabelText="Location"
                    xValue={
                      sLoadObj.loc === "" ? vRdxuserLoc[0]?.UID : sLoadObj.loc
                    }
                    xOnChange={(event) => fOnChangeSelect(event)}
                    xName={"loc"}
                    xData={sLocation}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid item md={4} xs={6} className="bintransfer-data-date">
                  <CmpDatePicker
                    xLabelText={"From"}
                    xValue={sLoadObj.dateFrom}
                    xOnChange={(newValue) => {
                      setLoadObj((obj) => ({ ...obj, dateFrom: newValue.$d }));
                    }}
                    xName={"dateFrom"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid item md={4} xs={6} className="bintransfer-data-date">
                  <CmpDatePicker
                    xLabelText={"To"}
                    xValue={sLoadObj.dateTo}
                    xOnChange={(newValue) =>
                      setLoadObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                    }
                    xName={"dateTo"}
                    xError={false}
                    xErrorMessage={false}
                  />
                </Grid>
                <Grid item md={4} xs={6}>
                  <CmpSelectBox
                    xLabelText="Status"
                    xValue={
                      sLoadObj.statusVal == ""
                        ? statusData[0].id
                        : sLoadObj.statusVal
                    }
                    xOnChange={(event) => fOnChangeSelect(event)}
                    xName={"statusVal"}
                    xData={statusData}
                    xValueMember={""}
                    xDispalyMember={""}
                    xError={false}
                    xErrorMessage={false}
                    xDisable={false}
                  />
                </Grid>
                <Grid item md={4} xs={12}>
                  <CmpTextFieldEnter
                    xref={LocationLoadingFocusOnLoad}
                    xLabelText={"Scan"}
                    xVariant={"outlined"}
                    xValue={sLoadObj.scan}
                    xOnChange={(event) => fOnChangeInput(event)}
                    xReadOnly={false}
                    xType={"text"}
                    xName={"Scan"}
                    xOnKeyUp={(e) => {
                      fOnKeyUp(e);
                    }}
                    xOnEnter={(e) => {
                      fOnKeyUp(sEnterKeyObj);
                    }}
                    xSmShow={!!vMediaQuery}
                  />
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  xs={12}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpButton
                    xbtnName="Load"
                    xOnClick={fLoad}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>
              </Grid>
            </>
          }
        />
      </div>
      {/* loading palletId Modal */}
      <CycleCustomModal
        open={loadingPalletIdOpen}
        onClose={() => SetLoadingPalletIdOpen(false)}
        vMediaQuery={vMediaQuery}
        xMediaQuery={xMediaQuery}
        title="Loading PalletId"
      >
        <LoadingPalletId selectedData={selectedData} />
      </CycleCustomModal>
      <UpdatedTruck
        xOpen={updatedTruck}
        CloseUpdatedTruckModal={CloseUpdatedTruckModal}
        xTitle="Updated Truck"
        selectedData={selectedData}
        // fNewDetail={fNewDetail}
        // dispatch={dispatch}
        // sTruckArr={sTruckArr}
      />
      <GCWebReport
        xfCloseWebReportModal={() => setWebReportModal(false)}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </>
  );
}
